var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8965 9.3769C27.8965 5.94819 25.2763 3.30078 22.1941 3.30078L9.16531 3.30078C6.08939 3.30078 3.46289 5.94921 3.46289 9.3769L3.46289 23.0601C3.46289 26.4857 6.08014 29.1285 9.17263 29.1285H22.1941C25.2719 29.1285 27.8965 26.4857 27.8965 23.0601V9.3769ZM22.1941 0.300781C27.0754 0.300781 30.8965 4.43727 30.8965 9.3769V23.0601C30.8965 28.0027 27.0652 32.1285 22.1941 32.1285H9.17263C4.28683 32.1285 0.462891 28.0027 0.462891 23.0601V9.3769C0.462891 4.43625 4.29222 0.300781 9.16531 0.300781H22.1941ZM17.5898 15.3535H23.2188V18.3535H17.5898V24.1318H14.5898V18.3535H8.96419V15.3535H14.5898V9.57617H17.5898V15.3535Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/IconUpload.68ec2e3f659a8f413c5bf4a46d5bdffc.svg";
export { ForwardRef as ReactComponent };